var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.768,
    height: 40,
    viewBox: "0 0 40.768 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "building-3",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91183",
    "data-name": "Path 91183",
    d: "M41.2,22.881H2.065a.815.815,0,1,1,0-1.631H41.2a.815.815,0,1,1,0,1.631Z",
    transform: "translate(-2 16.35)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91184",
    "data-name": "Path 91184",
    d: "M3.085,41.652a.815.815,0,0,1-.815-.815L2.25,11.6a4.73,4.73,0,0,1,2.1-3.925l7.83-5.226a4.717,4.717,0,0,1,5.251,0l7.825,5.223a4.692,4.692,0,0,1,2.1,3.927l.02,29.2a.815.815,0,0,1-.814.816l-23.482.039ZM14.806,3.283a3.069,3.069,0,0,0-1.717.522L5.26,9.031A3.1,3.1,0,0,0,3.881,11.6L3.9,40.02l21.851-.037L25.732,11.6a3.068,3.068,0,0,0-1.376-2.569L16.526,3.806A3.071,3.071,0,0,0,14.806,3.283Z",
    transform: "translate(-1.043 -2.402)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91185",
    "data-name": "Path 91185",
    d: "M20.045,26.728a.815.815,0,0,1-.815-.815V18.065a.815.815,0,1,1,1.631,0v7.847A.815.815,0,0,1,20.045,26.728Z",
    transform: "translate(15.204 12.522)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91186",
    "data-name": "Path 91186",
    d: "M21.979,11.25a4.734,4.734,0,0,1,4.729,4.729v3.914a4.729,4.729,0,0,1-9.458,0V15.979A4.734,4.734,0,0,1,21.979,11.25Zm0,11.741a3.1,3.1,0,0,0,3.1-3.1V15.979a3.1,3.1,0,1,0-6.2,0v3.914A3.1,3.1,0,0,0,21.979,22.991Z",
    transform: "translate(13.31 6.781)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91187",
    "data-name": "Path 91187",
    d: "M26.548,14.881H3.065a.815.815,0,0,1,0-1.631H26.548a.815.815,0,1,1,0,1.631Z",
    transform: "translate(-1.043 8.695)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91188",
    "data-name": "Path 91188",
    d: "M9.065,26.469a.815.815,0,0,1-.815-.815V18.315a.815.815,0,1,1,1.631,0v7.338A.815.815,0,0,1,9.065,26.469Z",
    transform: "translate(4.698 12.762)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91189",
    "data-name": "Path 91189",
    d: "M10.5,14.251A3.751,3.751,0,1,1,14.251,10.5,3.755,3.755,0,0,1,10.5,14.251Zm0-5.871a2.12,2.12,0,1,0,2.12,2.12A2.122,2.122,0,0,0,10.5,8.381Z",
    transform: "translate(3.263 2.475)",
    fill: "#09143a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.a931a84f73c756dad442b9938d84a0eb.svg";
export { ForwardRef as ReactComponent };